/* eslint-disable */
import { initVideoSlider } from "./video-slider.js";

export function initSliders() {
	initVideoSlider();
}
